import { Ad } from './ad';
import { Event } from './event';
import { Publication } from './publication';
import { HelpTraining } from './helpTraining';
import { StaticPage } from './staticPage';

export const cms = { ...Ad, ...Event, ...Publication, ...HelpTraining, ...StaticPage };
